export default "<app-toolbar></app-toolbar>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"